import React from 'react'
import Link from 'components/Link'

export function Breadcrumbs({ crumbs }) {
    if (!crumbs || crumbs.length === 0) return null

    return (
        <nav className="superadmin-breadcrumbs" aria-label="Breadcrumb">
            {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1
                return (
                    <React.Fragment key={crumb.label}>
                        {index > 0 && ' › '}
                        {crumb.href && !isLast ? (
                            <Link href={crumb.href}>{crumb.label}</Link>
                        ) : (
                            <span>{crumb.label}</span>
                        )}
                    </React.Fragment>
                )
            })}
        </nav>
    )
}
